const url = "http://103.41.205.45:1949";
const master = "http://103.41.205.45:1936";
const membership = "http://103.41.205.45:1935";
const superStudent = 'https://development.niecindonesia.com';
const superStudentApplication = 'https://development.niecindonesia.com/api/v1/application';
const masterKey = 'koibg3kyOxX73kKTNwCsbNXnocy6nMPQ';
const membershipKey = 'FYzev0v4c2wLHoewHjLQHps1WxnhLgVB';
const isMakassarKey = 'WUhtZP40YhPa39Fg5zdOubgE4Zjb8bJN';
const ambassadorKey = 'Y3G4gG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV';
const BASEURL = 'https://development.niecindonesia.com'

const API_URL = {
    url,
    master,
    membership,
    superStudent,
    superStudentApplication,
    masterKey,
    membershipKey,
    ambassadorKey,
    isMakassarKey,
    BASEURL,
}

export default API_URL;